import { Box, Typography } from '@mui/material'
import { leadershipStats } from '../../data/leadershipContent'
import { sectionHeadingSx } from '../../theme/mobileLayout'

function StatCard({ value, label }) {
  return (
    <Box
      sx={{
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'center',
          textAlign: 'center',
          color: '#111',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 32, sm: 38, lg: 44 },
            lineHeight: 'normal',
            fontWeight: 400,
            whiteSpace: 'nowrap',
          }}
        >
          {value}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 20, sm: 24, lg: 28 },
            lineHeight: 'normal',
            fontWeight: 400,
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  )
}

export default function LeadershipStatsSection() {
  return (
    <Box component="section" sx={{ width: '100%' }}>
      <Typography
        component="h2"
        sx={{
          ...sectionHeadingSx,
          mb: { xs: 5, md: 8, lg: '80px' },
        }}
      >
        Transforming Potential Into Leadership
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' },
          gap: { xs: 3, lg: '40px' },
        }}
      >
        {leadershipStats.map((stat) => (
          <StatCard key={stat.label} {...stat} />
        ))}
      </Box>
    </Box>
  )
}
